import { render, staticRenderFns } from "./function-content.vue?vue&type=template&id=e64b0772&scoped=true"
import script from "./function-content.vue?vue&type=script&lang=js"
export * from "./function-content.vue?vue&type=script&lang=js"
import style0 from "./function-content.vue?vue&type=style&index=0&id=e64b0772&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64b0772",
  null
  
)

export default component.exports